// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3C7TX","description":"PatientConsentPreview_description__3eSnN"};